export const iconsByFileExt = {
	pdf: 'AdobePDFIcon',
	doc: 'WordFileIcon',
	docx: 'WordFileIcon',
	xls: 'ExcelIcon',
	xlsx: 'ExcelIcon',
	key: 'KeynoteIcon',
	numbers: 'NumbersFileIcon',
	pages: 'PagesFileIcon',
	ppt: 'PowerpointIcon',
	pptx: 'PowerpointIcon',
	zip: 'ZipFileIcon',
	generic: 'GenericFileIcon',
}

export const MESSAGE_PAGE_SIZE = 50
export const MAX_CHARS = 5000
export const MAX_UNREADS = 100
export const UNREAD_LABEL = `${MAX_UNREADS - 1}+`
export const MAX_PINNED_CHATS = 20
export const MAX_RECENT_CHATS = 10
export const MAX_MESSAGE_MEDIA = 10
export const MAX_MESSAGE_MEDIA_SIZE_BYTES = 1000000000
export const IMAGE_MAX_WIDTH = 400
export const USER_TYPING_EVENT_INTERVAL_MS = 4000
export const MAX_RECENT_SEARCHES = 5
export const MAX_DM_MEMBERS = 10
export const MAX_REACTIONS_PER_USER = 10
export const MAX_REACTIONS_PER_MESSAGE = 30

export const LOG_TABLE_NAME = 'logs'

export const environments = {
	DEV: 'dev',
	BETA: 'beta',
	PROD: 'prod',
	SANDBOX: 'sandbox',
}

export const SUPPORTED_LOCALES = {
	en: true,
	es: true,
	pt: true,
}

export const inviteAccessTypes = {
	INTERNAL: 'internal',
	EXTERNAL: 'external',
}

export const categorySortTypes = {
	NAME: 'name',
	RECENT: 'recent',
}

export const mediaTypes = {
	FILE: 'FILE',
	PHOTO: 'PHOTO',
	VIDEO: 'VIDEO',
	AUDIO: 'AUDIO',
}

export const onboardingSteps = {
	PROFILE_PIC: 'profilepic',
	PRONOUNS: 'pronouns',
	TITLE: 'title',
}

export const sortTypes = {
	NEWEST: 'newest',
	OLDEST: 'oldest',
	RELEVANCE: 'relevance',
}

export const imageResizePresets = {
	PHOTO: 'PHOTO', // 1.44 megapixels
	PROFILE_PIC: 'PROFILE_PIC', // 0.25 megapixels
	ORG_PROFILE_PIC: 'ORG_PROFILE_PIC', // 0.25 megapixels
}

export const pollStates = {
	OPEN: 'OPEN',
	CLOSED: 'CLOSED',
	PROCESSING: 'PROCESSING',
}

export const supportedReactions = [
	{ id: 1, label: 'accessibility_message_reaction_thumbsup', native: '👍️' },
	{ id: 2, label: 'accessibility_message_reaction_thumbsdown', native: '👎️' },
	{ id: 4, label: 'accessibility_message_reaction_heart', native: '❤️' },
	{ id: 3, label: 'accessibility_message_reaction_joy', native: '😂' },
	{ id: 6, label: 'accessibility_message_reaction_wow', native: '😮' },
	{ id: 5, label: 'accessibility_message_reaction_cry', native: '😢' },
]

export const colorSchemes = {
	SYSTEM: 'system',
	DARK: 'dark',
	LIGHT: 'light',
}

export const colorContrasts = {
	SYSTEM: 'system',
	HIGH: 'high',
	NORMAL: 'normal',
}

export const cssColors = {
	// design lib
	neutral0: '#ffffff',
	neutral100: '#f3f4f5',
	neutral200: '#e7e7e8',
	neutral300: '#b8b9bd',
	neutral400: '#9c9ea4',
	neutral40040: '#9c9ea466', // neutral-400 at 40% opacity
	neutral500: '#81848a',
	neutral600: '#606265',
	neutral700: '#4e5053',
	neutral800: '#2c2d31',
	neutral900: '#141720',
	teal100: '#dbfef8',
	teal200: '#99f0e2',
	teal300: '#00dab6',
	teal400: '#059D84',
	blue100: '#e6f0f6',
	blue200: '#aed2e8',
	blue300: '#49a4da',
	blue400: '#1083c7',
	purple100: '#dde9ff',
	purple200: '#99bdff',
	purple300: '#5a91f9',
	red100: '#f3c1c9',
	red200: '#e06477',
	red300: '#c32f42',
	red400: '#ff3b30',
	yellow100: '#fff3d2',
	yellow200: '#ffd86c',
	yellow300: '#ffbb00',
	// old
	prontoGreen: '#00dab6',
	prontoBlue: '#49a4da',
	highlightBlue: '#095cf6',
	errorRed: '#e06477',
	errorRedHover: '#c34f42',
	outlineGray: '#e4e6e8',
	sidebarGray: '#f0f2f3',
	textGray: '#9c9ea4',
	textGrayMedium: '#606265',
	textGrayDark: '#2c2d31',
	neutral300Dark: '#353535',
}

export const cssColorsDark = {
	...cssColors,
	neutral0: '#1f1f1f',
	neutral100: '#101010',
	neutral200: '#2c2d31',
	neutral300: '#353535',
	neutral600: '#b8b9bd',
	neutral700: '#4e5053',
	neutral800: '#dcdcdc',
	teal200: '#059d84',
	blue200: '#3c7ca2',
	red400: '#ff453a',
}

export const cssColorsContrast = {
	...cssColors,
	red100: '#D5395B',
	red200: '#9E1F32',
	red300: '#A02737',
	red400: '#B30900',
	yellow100: '#6B4F00',
	teal100: '#0F6153',
	teal200: '#0F6153',
	teal300: '#00856F',
	blue100: '#2D5D7B',
	blue200: '#1A5A7F',
	blue300: '#1B5D83',
	purple100: '#004BD6',
	purple200: '#0049D1',
	neutral0: '#FFFFFF',
	neutral100: '#F3F4F5',
	neutral200: '#E7E7E8',
	neutral300: '#606265',
	neutral400: '#4E5053',
	neutral500: '#2C2D31',
	neutral600: '#2C2D31',
	neutral700: '#2C2D31',
	neutral800: '#2C2D31',
	neutral900: '#141720',
}

export const cssColorsDarkContrast = {
	...cssColorsDark,
	red300: '#E18490',
	red400: '#FF6961',
	blue200: '#56ABDC',
	blue300: '#2BA6EE',
	// // top row of colors in design library
	// neutral200: '#9D9FA4',
	// neutral300: '#9D9FA4',
	// neutral400: '#9D9FA4',
	// neutral500: '#9D9FA4',
	// neutral600: '#B8B9BD',
	// neutral800: '#FFFFFF',
	// neutral900: '#959CBB',
	// bottom row of colors in design library
	neutral0: '#1f1f1f',
	neutral100: '#101010',
	neutral200: '#2C2D31',
	neutral300: '#353535',
	neutral400: '#B8B9BD',
	neutral500: '#B8B9BD',
	neutral600: '#B8B9BD',
	neutral800: '#FFFFFF',
	neutral900: '#141720',
}

export const transcodeJobStatus = {
	UNKNOWN: 'UNKNOWN',
	SUBMITTED: 'SUBMITTED',
	QUEUED: 'QUEUED',
	PROBING: 'PROBING',
	TRANSCODING: 'TRANSCODING',
	UPLOADING: 'UPLOADING',
	COMPLETED: 'COMPLETED',
	ERRORED: 'ERRORED',
}
